import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Product } from '../../../../../../shared/types/systemConfiguration/products';

export const useProductData = (product?: Product) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            code: '',
            description: '',
            active: true,
            applyEscalations: true,
            applyPqr: true,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            name: product?.name || '',
            code: product?.code || '',
            description: product?.description || '',
            active: product?.active ?? false,
            applyEscalations: product?.applyEscalations ?? false,
            applyPqr: product?.applyPqr ?? false,
        });
    }, [product]);

    return {
        formik,
    };
};
